const config = {
  ApiGateway: 
  {
   Endpoint: process.env.REACT_APP_NADHEO_ENDPOINT
  },
  Cognito:
  {
    Region: "eu-west-1",
    UserPoolId: "eu-west-1_aSigjVkoc",
    AppClientId: "1kn2qdbh9doioses40cc0gvd7",
    IdentityPoolId: "eu-west-1:a7dc674f-c605-44c7-a4c4-5d05f2ea5485",
    Domain: "nadheo3.auth.eu-west-1.amazoncognito.com",
    RedirectSignIn: "https://vcvl.nadheo.eu",
    RedirectSignOut: "https://vcvl.nadheo.eu",
    OauthResponseType: "code",
    PwdFreeUserPoolId: "eu-west-1_k0qrUCrpz",
    PwdFreeAppClientId: "6e0lk2hpec8kvu3aln0seb4ihk"
  },
  Locize:
  {
    ProjectNamespace: "vcvl"
  }
};

export default config;
